import { Typography, colors } from '@leapeasy/ui-kit';
import { Box } from '@mui/material';
import { PORTAL_GUIDE_TRAINING_VIDEOS } from 'utils/portalGuideUi';

const videoStyle = {
  width: '100%',
  maxWidth: '800px',
  borderRadius: '8px',
  backgroundColor: '#000',
};

export const TrainingVideosPage = () => {
  return (
    <Box marginLeft="30px">
      <Typography
        variant="h2"
        style={{
          color: colors.purple[900],
          fontWeight: '500',
          paddingBottom: '10px',
          paddingTop: '10px',
        }}
      >
        Training Videos
      </Typography>
      <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
        Watch Partnerships training videos for common Leap Portal workflows.
      </Typography>
      {PORTAL_GUIDE_TRAINING_VIDEOS.map((video) => (
        <Box key={video.title} sx={{ mt: 3 }}>
          <Typography
            variant="h3"
            style={{ color: colors.purple[900], fontWeight: '500', paddingBottom: '10px' }}
          >
            {video.title}
          </Typography>
          <video controls preload="metadata" title={video.title} style={videoStyle}>
            <source src={video.src} type="video/mp4" />
          </video>
        </Box>
      ))}
    </Box>
  );
};
